import { isUndefined } from '@antv/util'; // use `self` instead of `window`, account for non-window contexts, such as in Web Workers
// @see https://developer.mozilla.org/en-US/docs/Web/API/Window/self

export var supportsTouchEvents = !!self.TouchEvent;
export var supportsPointerEvents = !!self.PointerEvent;
export var MOUSE_POINTER_ID = 1;
export var TOUCH_TO_POINTER = {
  touchstart: 'pointerdown',
  touchend: 'pointerup',
  touchendoutside: 'pointerupoutside',
  touchmove: 'pointermove',
  touchcancel: 'pointercancel'
};
export function isTouchEvent(event) {
  return supportsTouchEvents && event instanceof TouchEvent;
}
export function isMouseEvent(event) {
  return !self.MouseEvent || event instanceof MouseEvent && (!supportsPointerEvents || !(event instanceof self.PointerEvent));
}
/**
 * borrow from pixi/events
 */

export function normalizeToPointerEvent(event) {
  var normalizedEvents = [];

  if (isTouchEvent(event)) {
    for (var i = 0; i < event.changedTouches.length; i++) {
      var touch = event.changedTouches[i]; // use changedTouches instead of touches since touchend has no touches
      // @see https://stackoverflow.com/a/10079076

      if (isUndefined(touch.button)) touch.button = event.changedTouches.length ? 1 : 0;
      if (isUndefined(touch.buttons)) touch.buttons = event.changedTouches.length ? 1 : 0;

      if (isUndefined(touch.isPrimary)) {
        touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
      }

      if (isUndefined(touch.width)) touch.width = touch.radiusX || 1;
      if (isUndefined(touch.height)) touch.height = touch.radiusY || 1;
      if (isUndefined(touch.tiltX)) touch.tiltX = 0;
      if (isUndefined(touch.tiltY)) touch.tiltY = 0;
      if (isUndefined(touch.pointerType)) touch.pointerType = 'touch';
      if (isUndefined(touch.pointerId)) touch.pointerId = touch.identifier || 0;
      if (isUndefined(touch.pressure)) touch.pressure = touch.force || 0.5;
      if (isUndefined(touch.twist)) touch.twist = 0;
      if (isUndefined(touch.tangentialPressure)) touch.tangentialPressure = 0;
      touch.isNormalized = true;
      touch.type = event.type;
      normalizedEvents.push(touch);
    }
  } else if (isMouseEvent(event)) {
    var tempEvent = event;
    if (isUndefined(tempEvent.isPrimary)) tempEvent.isPrimary = true;
    if (isUndefined(tempEvent.width)) tempEvent.width = 1;
    if (isUndefined(tempEvent.height)) tempEvent.height = 1;
    if (isUndefined(tempEvent.tiltX)) tempEvent.tiltX = 0;
    if (isUndefined(tempEvent.tiltY)) tempEvent.tiltY = 0;
    if (isUndefined(tempEvent.pointerType)) tempEvent.pointerType = 'mouse';
    if (isUndefined(tempEvent.pointerId)) tempEvent.pointerId = MOUSE_POINTER_ID;
    if (isUndefined(tempEvent.pressure)) tempEvent.pressure = 0.5;
    if (isUndefined(tempEvent.twist)) tempEvent.twist = 0;
    if (isUndefined(tempEvent.tangentialPressure)) tempEvent.tangentialPressure = 0;
    tempEvent.isNormalized = true;
    normalizedEvents.push(tempEvent);
  } else {
    normalizedEvents.push(event);
  }

  return normalizedEvents;
}